import comp from "./Suggestions";
export default comp;
